import Modal from "react-modal";
import { useState, useEffect } from "react";
import "../styles/Modal.css";

Modal.setAppElement("#root");

const UserEditModal = ({ isOpen, onClose, user, onUpdateUser }) => {
    const [editedUser, setEditedUser] = useState({ email: "", roles: [] });

    useEffect(() => {
        if (user) {
            setEditedUser(user);
        }
    }, [user]);

    const handleSubmit = (e) => {
        e.preventDefault();
        onUpdateUser(editedUser);
    };

    return (
        <Modal isOpen={isOpen} onRequestClose={onClose} className="modal-content modal-content--sm" overlayClassName="modal-overlay">
            <div className="modal-header">
                <h2 className="modal-title">Edit user</h2>
                <button className="modal-close" onClick={onClose}>×</button>
            </div>
            <form onSubmit={handleSubmit} className="modal-form">
                <input
                    type="email"
                    value={editedUser.email}
                    onChange={(e) => setEditedUser({ ...editedUser, email: e.target.value })}
                    required
                />
                <button type="submit" className="modal-button">Save changes</button>
            </form>
        </Modal>
    );
};

export default UserEditModal;
